export const formatInput = (value) => {
  return Number(value).toFixed(2);
};
